import { merchantsAPI } from '@backmarket/http-api'
import { $httpFetch } from '@backmarket/nuxt-module-http/$httpFetch'
import { defineStore } from 'pinia'

// TODO the name shouldnt be singular?
export type BusinessFeaturesKeys =
  keyof merchantsAPI.GetMerchantFeatures.Response

export type TemporaryBusinessFeaturesKeys =
  keyof merchantsAPI.TemporaryBusinessFeatures

interface State {
  businessFeatures: merchantsAPI.GetMerchantFeatures.Response | null
}

export const useBusinessFeaturesStore = defineStore('businessFeatures', {
  actions: {
    async fetchBusinessFeatures() {
      this.businessFeatures = await $httpFetch(merchantsAPI.getMerchantFeatures)
    },
    /**
     * @example
     * const { isFeatureEnabled } = useBusinessFeaturesStore()
     * isFeatureEnabled('supportEnabled') // false | true
     */
    isFeatureEnabled(
      feature?: BusinessFeaturesKeys | TemporaryBusinessFeaturesKeys,
    ): boolean {
      const isTemporaryFeatureEnabled =
        this.businessFeatures?.temporary?.[
          feature as TemporaryBusinessFeaturesKeys
        ]
      const isPermanentFeatureEnabled =
        this.businessFeatures?.[feature as BusinessFeaturesKeys]

      return Boolean(
        feature && (isTemporaryFeatureEnabled || isPermanentFeatureEnabled),
      )
    },
  },
  getters: {
    hasFetchBusinessFeature: (state) => Boolean(state.businessFeatures),
  },
  state: (): State => ({
    businessFeatures: null,
  }),
})
